import { lazy } from "react"

export const Onboarding = lazy(() => import("./onboarding"))
